export default {
  loadBtn: false,

  config: [],

  newsletterDisplay: true,

  customerBanners: [],
  honorBanners: [],
  team: [],
  sliders: [],
  services: [],
  servicesById: [],

  tutorials: [],
  tutorialHome: [],
  tutorialsPage: [],
  tutorial: {},
  tutorialsPageTotal: [],

  products: [],
  productsHome: [],
  productsPage: [],
  product: [],
  productsPageTotal: [],
  relatedProducts: [],

  blogs: [],
  relatedBlogs: [],
  blogHome: [],
  blogsPage: [],
  blogsPageTotal: [],
  blog: [],

  galleries: [],
  galleryPage: [],
  gallery: [],
  galleryList: [],
  galleryListImage1: [],
  galleryPageTotal: [],

  categories: [],
  category: [],
  menus: [],
  socials: [],

  cities: [],
  states: [],
  activityField: [],

  comments: [],
  commentsLength: [],

  posters: [],

  dynamicPageContent: {},
  aboutPage: {},
  contactPage: {},

  support: {},

  rules: {},

  methodOfIntroductions: [],

  customerOpinion: [],
};
